import React from 'react';
import { CpOrderInvoicesDataItem } from '../list/cp_order_invoices_list_types';
import Panel from '../../../core/components/Panel';
import { lightFormat } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import utilSvc from '../../../core/utilSvc';

interface CpOrderInvoiceInformationPanelProps {
    invoice: CpOrderInvoicesDataItem;
    userAffList: any[];
}

const CpOrderInvoiceInformationPanel = ({ invoice, userAffList }: CpOrderInvoiceInformationPanelProps): JSX.Element => {
    // Format date for display
    const formatDate = (dateString?: string): string => {
        if (!dateString) return '—';
        return lightFormat(dateString, utilSvc.dt.fmtMdyyyyhmmssa);
    };
    // Format currency
    const formatCurrency = (amount?: number): string => {
        if (typeof amount !== 'number') return '—';
        return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    const accumRxName = invoice.AccumRXID ? utilSvc.aff.rxShortNameById(userAffList, invoice.AccumRXID) : '';
    return (
        <Panel
            flexDirection="column"
            noMinHeight
        >
            <div className="info-row">
                <div className="info-group no-expand">
                    <label>Pharmacy:</label>
                    <span>{invoice.Pharmacy || '—'}</span>
                </div>
                {accumRxName ? (
                    <div className="info-group no-expand">
                        <label>Accumulation Pharmacy:</label>
                        <span>{accumRxName}</span>
                    </div>
                ) : null}
                <div className="info-group no-expand">
                    <label>Facility:</label>
                    <span>{invoice.CEID || '—'}</span>
                </div>
                <div className="info-group no-expand">
                    <label>Vendor:</label>
                    <span>{invoice.VendorName || '—'}</span>
                </div>
                <div className="info-group no-expand">
                    <label>Account:</label>
                    <span>{invoice.AccumGrp || '—'}</span>
                </div>
            </div>
            <div className="info-row">
                <div className="info-group no-expand">
                    <label>Amount:</label>
                    <span>{formatCurrency(invoice.TotalAmount)}</span>
                </div>
                <div className="info-group no-expand">
                    <label>Order Type:</label>
                    <span>{invoice.Type || '—'}</span>
                </div>
                <div className="info-group no-expand">
                    <label>Order #:</label>
                    <span>{invoice.OrderNum || '—'}</span>
                </div>
                <div className="info-group no-expand">
                    <label>Invoice #:</label>
                    <span>{invoice.VendorInvoiceNum || '—'}</span>
                </div>
            </div>
            {!invoice.CreatedDate && !invoice.VendorInvoiceDate && !invoice.InvoiceReconciledDate ? null : (
                <div className="info-row">
                    {invoice.CreatedDate ? (
                        <div className="info-group no-expand">
                            <label>Order Placed:</label>
                            <span>{formatDate(invoice.CreatedDate)}</span>
                        </div>
                    ) : null}
                    {invoice.VendorInvoiceDate ? (
                        <div className="info-group no-expand">
                            <label>Invoiced:</label>
                            <span>{formatDate(invoice.VendorInvoiceDate)}</span>
                        </div>
                    ) : null}
                    {invoice.InvoiceReconciledDate ? (
                        <div className="info-group no-expand">
                            <label>Reconciled:</label>
                            <span>{formatDate(invoice.InvoiceReconciledDate)}</span>
                        </div>
                    ) : null}
                </div>
            )}
            {!invoice.CreatedBy && !invoice.Reviewer ? null : (
                <div className="info-row">
                    <div className="info-group no-expand">
                        <label>
                            <FontAwesomeIcon icon={faUser} /> Created By:
                        </label>
                        <span>{invoice.CreatedBy || '—'}</span>
                    </div>
                    <div className="info-group no-expand">
                        <label>
                            <FontAwesomeIcon icon={faUser} /> Reviewed By:
                        </label>
                        <span>{invoice.Reviewer || '—'}</span>
                    </div>
                </div>
            )}
        </Panel>
    );
};

export default CpOrderInvoiceInformationPanel;
